import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import router from '@/common/router.js'

if (process.env.APP_GA_ENABLED) {
  Vue.use(VueAnalytics, {
    id: process.env.APP_GA_ID,
    router
  })
}



// WEBPACK FOOTER //
// ./src/common/plugins/ga.js